import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { CustomersResponseDataSchema, DataResponseWithPagination, GetCustomersSchema } from "schema"
import { z } from "zod"

type Query = z.input<typeof GetCustomersSchema>
type Response = DataResponseWithPagination<z.infer<typeof CustomersResponseDataSchema>>
type OnSuccessFn = (data: Response) => void

export const getCustomersQueryKey = (query: Query = {}) => ["customers", query]

type Props = {
  query?: Query
  onSuccess?: OnSuccessFn
  enabled?: boolean
}

export const customersQuery = ({ query, onSuccess, enabled = true }: Props = {}) => {
  return queryOptions({
    queryKey: getCustomersQueryKey(query),
    enabled,
    queryFn: async () => {
      const { data } = await axios.get<Response>("/customers", { params: query })
      onSuccess?.(data)
      return data.data
    },
  })
}
